import { ReactComponent as SvgUpload } from '@img/icons/upload.svg';
import * as React from 'react';
import S from '../../UmbracoForm.styles';
const FileUpload = React.forwardRef(({ error, field, ...otherProps }, ref) => {
    const [fileName, setFileName] = React.useState('');
    return (React.createElement(S.Field, { "data-error": !!error, style: { '--inputHeight': '36px' } },
        React.createElement(S.FileUploadLabelContainer, null,
            React.createElement(S.ControlLabel, { tabIndex: -1, htmlFor: field.alias, "data-hover-styles": true },
                React.createElement(S.Input, { ref: ref, id: field.alias, multiple: false, type: "file", ...otherProps, onChange: (event) => {
                        const files = event.target.files ?? [];
                        if (files.length === 0) {
                            setFileName('');
                        }
                        setFileName(files[0].name);
                    } }),
                React.createElement(SvgUpload, null),
                field.caption,
                field.required && React.createElement(React.Fragment, null, " *")),
            fileName && React.createElement(S.FileNameContent, null, fileName)),
        error && React.createElement(S.Error, null, error.message)));
});
FileUpload.displayName = 'FileUpload';
export default FileUpload;
